export enum DateFormatType {
  european = 'EU',
  american = 'AM'
}
